import React from 'react';

interface IListEmptyIconProps {
  style?: any;
}

export const ListEmpty:React.FC<IListEmptyIconProps> = (props: IListEmptyIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="165" height="113" fill="none" viewBox="0 0 165 113">
        <path fill="url(#paint0_linear)" d="M163.221 92.018l-30.818 20.545c-.422.284-.918.436-1.426.437H2.568c-.362-.002-.72-.081-1.05-.232-.33-.15-.624-.369-.863-.641-.418-.466-.65-1.069-.655-1.695V23.114c0-.422.105-.837.305-1.21.2-.37.487-.688.838-.922L31.96.437c.43-.266.92-.416 1.425-.437h128.409c.682 0 1.335.27 1.816.752.482.482.753 1.135.753 1.816v87.318c-.001.422-.106.837-.305 1.21-.199.37-.487.688-.838.922zm-29.676 13.611l19.763-13.175h-19.763v13.175zM30.818 7.371L11.056 20.546h19.762V7.37zm0 18.31H5.136v79.948l25.682-17.117v-62.83zm-19.762 82.183h117.353v-15.41h-94.24l-23.113 15.41zm117.353-20.546V25.682H35.955v61.636h92.454zM35.955 5.136v15.41h94.239l23.114-15.41H35.955zm123.272 2.235l-25.682 17.117v62.83h25.682V7.371z"/>
        <defs>
            <linearGradient id="paint0_linear" x1="82.182" x2="82.182" y1="113" y2="0" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F76101"/>
                <stop offset="1" stopColor="#F46968"/>
            </linearGradient>
        </defs>
    </svg>
  )
}